export const getSalesForceChatOpenButton = () => document.querySelector('.uiButton.helpButtonEnabled');

export const getSalesForceChatCloseButton = () => {
    const salesForceChatContainer = document.querySelector('.dockableContainer');
    const salesForceChatCloseButton = salesForceChatContainer?.querySelector('.closeButton');

    return salesForceChatCloseButton;
};

export const isSalesForceChatOpen = () => !!getSalesForceChatCloseButton();
